import React, {useState} from "react";
import {useAuth} from "./AuthProvider";
import {useMutation} from "@tanstack/react-query";


let TeamContext = React.createContext(null);

const TeamProvider = ({children, criteria, team, onUpdated, ...props}) => {

    const {auth} = useAuth();

    const [isDisabled, setIsDisabled] = useState(false);
    /*
    |--------------------------------------------------------------------------
    | Handling Requests - Add/Remove Team to/from Shortlist/Archive
    |--------------------------------------------------------------------------
    */
    const teamRequestMutation = useMutation(['teamRequestMutation', team?.id],
        async ({method, successKey}) => {

            let updatedTeam = await team[method]()

            if (updatedTeam) {
                TB.sysAlert(successKey);
                return updatedTeam
            }

        }, {
            onError: async (e) => {
                await setIsDisabled(false)
                return TB.showServerErrorToast()
            },
            onSuccess: async (updatedCandidate) => {
                await setIsDisabled(false)
                // if (!updatedCandidate) {
                //     TB.showServerErrorToast()
                //     return false;
                // }
            }
        }
    )
    const runProjectTeamRequest = async (method, successKey) => {
        await setIsDisabled(true)

        let updatedCandidate = await teamRequestMutation.mutateAsync(
            {method, successKey}, {
                onError: async (e) => {
                    await setIsDisabled(false)
                    return TB.showServerErrorToast()
                },
                onSuccess: async (updatedCandidate) => {
                    await setIsDisabled(false)
                    // if (!updatedCandidate) {
                    //     TB.showServerErrorToast()
                    //     return false;
                    // }
                }
            });

        console.log('runProjectTeamRequest', updatedCandidate);

        await setIsDisabled(false)

        return updatedCandidate
    }

    const addToFavorites = async () => {
        return runProjectTeamRequest(
            'addToFavorites', 'byo.favorites_added'
        );
    }

    const removeFromFavorites = async () => {
        return runProjectTeamRequest(
            'removeFromFavorites', 'byo.favorites_removed'
        );
    }

    let value = {
        team,
        criteria,
        isDisabled,
        addToFavorites,
        removeFromFavorites,
        canFavorite: true,
    }

    return (
        <TeamContext.Provider value={value}>
            {children}
        </TeamContext.Provider>
    );
}

const useTeam = () => {
    return React.useContext(TeamContext);
}
export default TeamProvider;
export {
    useTeam,
    TeamContext
}